/*
 * DEMONTHA — Ürün sayfası güvence bloğu, taksit tutarı güncelleyici
 * ---------------------------------------------------------------------------
 * Eşi: snippets/dmt-pdp-assurance.liquid
 *
 * NEDEN AYRI DOSYA
 *   Bu kod önce snippet'in içinde satır içi <script> olarak duruyordu ve
 *   HİÇ ÇALIŞMIYORDU. Ölçüm: script sayfada mevcut (1731 karakter, doğru
 *   konumda), sözdizimi hatasız, elle eval edilince sorunsuz kuruluyor —
 *   ama sayfa yüklenirken çalışmıyor. Sebep: tema `.wt-product__info`
 *   kolonunu başlatırken innerHTML ile yeniden kuruyor (`no-js-hidden`
 *   sınıfı bunun izi) ve innerHTML ile yerleştirilen <script> düğümleri
 *   tarayıcı tarafından çalıştırılmaz. Bölüm dışından yüklenen harici
 *   dosya bu sorundan etkilenmiyor (aynı yolu dmt-dim-rows.js kullanıyor).
 *
 * NEDEN BELGE DÜZEYİNDE DİNLEYİCİ
 *   Varyant radyoları sepet formunun İÇİNDE DEĞİL — ayrı bir çekmecede
 *   (`drawer__list__item`). Forma bağlanan `change` dinleyicisi bu yüzden
 *   hiç tetiklenmiyordu. Dinleyiciler belge düzeyinde ve yakalama fazında.
 *
 * NEDEN HER SEFERİNDE YENİDEN SORGULAMA
 *   Tema varyant değişiminde kolonu yeniden basabiliyor; yükleme anında
 *   yakalanan düğüm referansları kopuk kalır. Hiçbir düğüm önbelleğe
 *   alınmıyor.
 *
 * NEDEN JS BİÇİMLENDİRME YOK
 *   Her varyantın taksit ve toplam metni Liquid'in `money` filtresiyle
 *   önceden basılıp JSON'a gömülü. JS yalnızca hazır metni yerleştirir.
 *   Böylece mağazanın para birimi biçimi neyse ekranda o görünür.
 */
(function () {
  'use strict';

  function tabloOku(blok) {
    var kutu = blok.querySelector('[data-dmt-assure-prices]');
    if (!kutu) return null;
    try {
      return JSON.parse(kutu.textContent);
    } catch (e) {
      return null; // bozuk tabloyla yanlış tutar göstermektense hiç dokunma
    }
  }

  function varyantId() {
    // 1) URL en güvenilir kaynak: tema varyant değişiminde ?variant= yazıyor
    try {
      var u = new URLSearchParams(window.location.search).get('variant');
      if (u) return u;
    } catch (e) {
      /* URLSearchParams yoksa gizli alana düş */
    }
    // 2) sepet formundaki gizli alan
    var form = document.querySelector('form[action*="/cart/add"]');
    var alan = form && form.querySelector('input[name="id"], select[name="id"]');
    return alan ? alan.value : null;
  }

  function guncelle() {
    var blok = document.querySelector('[data-dmt-assure-pay]');
    if (!blok) return;

    var taksitEl = blok.querySelector('[data-dmt-assure-taksit]');
    var toplamEl = blok.querySelector('[data-dmt-assure-toplam]');
    if (!taksitEl || !toplamEl) return;

    var tablo = tabloOku(blok);
    if (!tablo) return;

    var id = varyantId();
    if (!id) return;

    var kayit = tablo[String(id)];
    if (!kayit) return; // bilinmeyen varyant: eski değeri bozma

    if (taksitEl.textContent !== kayit.t) taksitEl.textContent = kayit.t;
    if (toplamEl.textContent !== kayit.g) toplamEl.textContent = kayit.g;
  }

  // Art arda gelen olaylarda tek çalıştırma
  var bekleyen = null;
  function planla(gecikme) {
    if (bekleyen) clearTimeout(bekleyen);
    bekleyen = setTimeout(function () {
      bekleyen = null;
      guncelle();
    }, gecikme);
  }

  // Yakalama fazı: çekmece içindeki radyolar dahil her değişimi görür.
  // Gecikme, temanın önce fiyatı ve URL'yi yazmasına izin veriyor.
  document.addEventListener('change', function () { planla(80); }, true);
  document.addEventListener('click', function () { planla(220); }, true);
  window.addEventListener('popstate', function () { planla(0); });
  document.addEventListener('variant:change', function () { planla(0); });

  // Fiyat kutusu değişimini de izle: yukarıdaki olayların hiçbiri
  // yakalanmazsa (tema kendi yolunu değiştirirse) bu ağ tutar.
  function gozlemciKur() {
    var fiyat = document.querySelector('.wt-product__price');
    if (!fiyat || !('MutationObserver' in window)) return;
    new MutationObserver(function () { planla(60); })
      .observe(fiyat, { childList: true, subtree: true, characterData: true });
  }

  function baslat() {
    gozlemciKur();
    guncelle();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', baslat);
  } else {
    baslat();
  }
})();
